import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

export function useVendorPortalScope() {
  const authStore = useAuthStore()

  const vendorScope = computed(() => authStore.user?.vendorScope ?? null)
  const isVendorScoped = computed(() => vendorScope.value?.mode === 'restricted')
  const isOwnerScope = computed(() => !isVendorScoped.value)
  const scopedVendorIds = computed<number[]>(() => {
    const fromScope = Array.isArray(vendorScope.value?.vendorIds) ? vendorScope.value.vendorIds : []
    const fromMemberships = Array.isArray(authStore.user?.vendorMemberships)
      ? authStore.user.vendorMemberships
          .filter((membership) => String(membership.status || 'active').toLowerCase() === 'active')
          .map((membership) => membership.vendorId)
      : []
    return [...new Set([...fromScope, ...fromMemberships]
      .map((value) => Number(value))
      .filter((value) => Number.isInteger(value) && value > 0))]
  })

  return {
    vendorScope,
    isVendorScoped,
    isOwnerScope,
    scopedVendorIds,
  }
}
